import { createFileRoute, redirect } from "@tanstack/react-router";

/** A bare gateway URL has no page of its own, so it opens the gateway's edit page. */
export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways/$gatewayId/"
)({
  beforeLoad({ params }) {
    throw redirect({
      params: {
        organizationId: params.organizationId,
        projectId: params.projectId,
        gatewayId: params.gatewayId,
      },
      replace: true,
      search: true,
      to: "/orgs/$organizationId/projects/$projectId/mcp-gateways/$gatewayId/edit",
    });
  },
});
